import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthUser } from "./authApi";

interface AuthState {
  user: AuthUser | null;
  initialized: boolean;
  setUser: (user: AuthUser) => void;
  clearUser: () => void;
  setInitialized: () => void;
}

/**
 * Minimal signed-in-user store for the admin app — a trimmed copy of
 * packages/frontend/src/stores/authStore.ts without the onboarding/persona/
 * subscription-tier fields that only make sense for platform users, not
 * admins. Persisted to localStorage under its own key so it cannot collide
 * with the frontend app's "spark-auth" key even if the two are ever tested
 * against the same origin.
 */
export const useAdminAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      initialized: false,
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: null }),
      setInitialized: () => set({ initialized: true }),
    }),
    { name: "spark-admin-auth", partialize: (state) => ({ user: state.user }) }
  )
);

/** Same shape/intent as isTrulyAuthenticated in the frontend's authStore. */
export function isTrulyAuthenticated(user: unknown): boolean {
  return !!user && !!sessionStorage.getItem("spark_access_token");
}
